import React from 'react';
import Badge from '@material-ui/core/Badge';
import { ResourceRequestIcon } from '~/modules/common/components/Icons';
import { ResourceRequestAccessLevel } from '~/types';
import { getRoutePermissions } from '~/modules/common/permissions';
import { useMeContext } from '~/modules/me/useMeContext';
import {
  useResourcePlanSummaryCounts,
  useResourcePlanSummaryCountRefetchSubscription
} from './common/hooks';

export const MAX_NOTIFICATIONS = 9;

export const ResourcingBadgeIcon = () => {
  const me = useMeContext();
  const { isPsaRmpEnhancedPM2Enabled } = me.featureFlags;
  const { canViewResourcing } = getRoutePermissions(me);

  const {
    loading,
    pendingCount = 0,
    allocationRejectedCount,
    refetch
  } = useResourcePlanSummaryCounts({
    requestAccessLevel: ResourceRequestAccessLevel.ResourceManager,
    skip: isPsaRmpEnhancedPM2Enabled && !canViewResourcing
  });

  const resourceCount = pendingCount + allocationRejectedCount;

  useResourcePlanSummaryCountRefetchSubscription({ refetch });

  const showBadge = !isPsaRmpEnhancedPM2Enabled || canViewResourcing;

  if (!loading && resourceCount > 0 && showBadge) {
    return (
      <Badge
        overlap="rectangular"
        badgeContent={
          resourceCount > MAX_NOTIFICATIONS
            ? `${MAX_NOTIFICATIONS}+`
            : resourceCount
        }
        color="secondary"
        data-qe-id="resourcing_Count"
      >
        <ResourceRequestIcon />
      </Badge>
    );
  }

  return <ResourceRequestIcon />;
};

export default ResourcingBadgeIcon;
